var _circle, _path, _line, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteAndAppDevelopmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0.5C18.497 0.5 17.4986 0.976181 16.5441 1.9261C15.5876 2.87804 14.7032 4.28058 13.9498 6.05344C12.4436 9.59724 11.5 14.5278 11.5 20C11.5 25.4722 12.4436 30.4028 13.9498 33.9466C14.7032 35.7194 15.5876 37.122 16.5441 38.0739C17.4986 39.0238 18.497 39.5 19.5 39.5C20.503 39.5 21.5014 39.0238 22.4559 38.0739C23.4124 37.122 24.2968 35.7194 25.0502 33.9466C26.5564 30.4028 27.5 25.4722 27.5 20C27.5 14.5278 26.5564 9.59724 25.0502 6.05344C24.2968 4.28058 23.4124 2.87804 22.4559 1.9261C21.5014 0.976181 20.503 0.5 19.5 0.5Z",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 19.5,
    x2: -4.37114e-8,
    y2: 19.5,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 11.5C37.5 11.5 28.5 12.5 20 12.5C11.5 12.5 2.5 11.5 2.5 11.5",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 27.5C38 27.5 28.5 26 20 26C11.5 26 2 27.5 2 27.5",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5V39.5",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteAndAppDevelopmentIcon);
export default __webpack_public_path__ + "static/media/websiteAndAppDevelopmentIcon.8d858f1cf12c0e7496ec84e0b61f5983.svg";
export { ForwardRef as ReactComponent };